<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
                <b-row>
                    <b-col xl="12" lg="12" sm="12">
                        <b-overlay :show="loading" rounded="sm">
                        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                            <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset">
                                <b-row>
                                    <b-col lg="4" md="4" sm="4" xs="12">
                                        <ValidationProvider name="Memo No" vid="memo_no" rules='required'>
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="memo_no"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                    {{ $t('assitive_device_management.memo_no')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-input
                                                    id="memo_no"
                                                    v-model="data.memo_no"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    @change="getFundRecieveInfo"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col lg="4" md="4" sm="4" xs="12">
                                        <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="4"
                                                label-for="fiscal_year_id"
                                                slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{$t('globalTrans.fiscal_year')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="data.fiscal_year_id"
                                            :options="fiscalYearList"
                                            id="fiscal_year_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            disabled
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                                      <ValidationProvider name="Fund Received Date" vid="fund_recieved_date" rules="required">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="fund_recieved_date"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                              {{ $t('assitive_device_management.fund_recieved_date') }} <span class="text-danger">*</span>
                                            </template>
                                            <flat-pickr class="form-control"
                                            v-model="data.fund_recieved_date"
                                            id="fund_recieved_date"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            </flat-pickr>
                                          <div class="invalid-feedback d-block" v-if="errors.length">
                                            {{ errors[0] }}
                                          </div>
                                        </b-form-group>
                                      </ValidationProvider>
                                    </b-col>
                                    <b-col lg="6" sm="6">
                                    </b-col>
                                    <b-col lg="1" sm="1">
                                    </b-col>
                                </b-row>
                                <b-row class="mb-4 mt-2" style="border: 1px solid black;padding-top: 23px;padding-bottom: 27px;}">
                                <table class="m-auto mb-4">
                                    <thead style="background-color: #44B2D8;">
                                    <tr>
                                        <th>{{$t('globalTrans.sl_no')}}</th>
                                        <th>{{ $t('assitive_device_management.assistive_device_name')}}</th>
                                        <th>{{ $t('assitive_device_management.requisition_quantity')}}</th>
                                        <th>{{ $t('assitive_device_management.funding_quantity')}}</th>
                                        <th>{{ $t('assitive_device_management.unit_price')}}</th>
                                        <th>{{ $t('assitive_device_management.total_tk')}}</th>
                                        <th>{{$t('globalTrans.action')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in AddmoreArray" :key="index" >
                                        <td style="color:black;">{{$n(index + 1)}}</td>
                                        <td style="color:black;">
                                        <ValidationProvider name="Quantity" vid='quantity' rules="">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="1"
                                                label-for="quantity"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <b-form-select
                                                disabled
                                                plain
                                                v-model="item.assistive_device_id"
                                                :options="assistiveDeviceList"
                                                id="assistive_device_id"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                </template>
                                                </b-form-select>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                        </td>
                                        <td style="color:black;">
                                        <ValidationProvider name="Quantity" vid='quantity' rules="">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="1"
                                                label-for="quantity"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <b-form-input
                                                id="quantity"
                                                v-model="item.requisition_quantity"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                disabled
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                        </td>
                                        <!-- <td style="color:black;">
                                        <ValidationProvider name="Funding Quantity" vid='funding_quantity' :rules="required">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="1"
                                                label-for="funding_quantity"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <b-form-input
                                                id="funding_quantity"
                                                v-model="item.funding_quantity"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                @input="FundingQuantityChangeArray(item,index)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                        </td> -->
                                        <td style="color:black;">
                                        <ValidationProvider name="Funding Quantity" :vid="`AddmoreArrayO.${index}funding_quantity`" :rules="`required|max_value:${item.requisition_quantity}`">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="1"
                                                label-for="`AddmoreArrayO.${index}funding_quantity`"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <b-form-input
                                                id="`AddmoreArrayO.${index}funding_quantity`"
                                                v-model="item.funding_quantity"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                @input="totalChange(index)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                        </td>
                                        <td style="color:black;">
                                        <ValidationProvider name="Quantity" vid='quantity' rules="">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="1"
                                                label-for="quantity"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <b-form-input
                                                id="quantity"
                                                v-model="item.unit_price"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                disabled
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                        </td>
                                        <td style="color:black;">
                                        <ValidationProvider name="Quantity" vid='quantity' rules="">
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="1"
                                                label-for="quantity"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <b-form-input
                                                disabled
                                                id="quantity"
                                                v-model="item.total_price"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                        </td>
                                         <td><button @click="delItem(index)" class="btn btn-sm btn-danger mr-2 float-right mt-1" type="button" ><i class="far fa-trash-alt m-0"></i></button></td>
                                    </tr>
                                </tbody>
                                <b-tfoot>
                                    <b-tr>
                                        <b-th colspan="2" class="text-right">{{ $t('sitePreference.grandTotal') }}</b-th>
                                        <b-th class="text-right">{{ $n(grandTotalInfo.requisition_quantity) }}</b-th>
                                        <b-th class="text-right">{{ $n(grandTotalInfo.funding_quantity) }}</b-th>
                                        <b-th></b-th>
                                        <b-th class="text-right">{{ $n(grandTotalInfo.total_price) }}</b-th>
                                        <b-th></b-th>
                                    </b-tr>
                                </b-tfoot>
                                </table>
                                </b-row>
                                <b-row>
                                </b-row>
                                <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
<!--                                    <b-button type="submit" variant="primary" class="mr-2" @click="prevent($event)">{{ saveBtnName }}</b-button>-->
                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                    &nbsp;
                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                </div>
                                </div>
                            </b-form>
                        </ValidationObserver>
                        </b-overlay>
                    </b-col>
                </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { fundRecievedStore, fundRecievedUpdate, fundRecievedListRetrive, fundRecievedListRetriveTwo } from '../../api/routes'
import { helpers } from '@/mixins/helper-functions'
// import Custom from '../../../../../store/custom'

export default {
    name: 'FormLayout',
    props: ['id', 'item', 'fundRecievedDetails'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
      if (this.id) {
          this.AddmoreArray.push(...this.item.details)
          this.predata = this.getData()
          this.data.fiscal_year_id = this.predata.fiscal_year_id
          this.data.memo_no = this.predata.memo_no
          this.data.fund_recieved_date = this.predata.fund_recieved_date
          this.getFundRecieveInfoTwo()
      }
    },
    mounted () {
        core.index()
        this.data = Object.assign({}, this.data, {
            fund_recieved_date: helpers.currentDate()
        })
    },
    data () {
        return {
            ItemShow: false,
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            predata: null,
            loading: false,
            myVar: true,
            AssitiveDeviceList: [],
            details: [],
            data: {
                memo_no: '',
                fiscal_year_id: 0,
                fund_recieved_date: '',
                AddmoreArrayO: []
            },
            validationArray: [],
            addmorelist:
             {
                assistive_device_id: '',
                requisition_quantity: '',
                funding_quantity: '',
                unit_price: '',
                total_price: ''
            },
            AddmoreArray: [],
            grandTotalInfo: {
                requisition_quantity: 0,
                funding_quantity: 0,
                total_price: 0
            }
        }
    },
    computed: {
        assistiveDeviceList: function () {
        return this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.filter(item => item.status === 1)
        },
        fiscalYearList: function () {
        return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
        },
        yearList () {
          return helpers.getYearList()
        },
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        fiscalYear: function () {
            const objectData = this.$store.state.commonObj.fiscalYearList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        }
    },
    watch: {
    'data.organization': function (newVal) {
      this.officeTypeList = this.getofficeTypeList(newVal)
    },
    'data.institute_type': function (newVal) {
      this.officeList = this.getOfficeList(newVal)
    }
    },
    methods: {
      prevent () {
          if (this.data.fund_recieved_date === '') {
            this.$toast.error({
                        title: 'Error',
                        message: 'Please fill fund recieved date field'
            })
            event.preventDefault()
          }
      },
      totalChange (index) {
          if (this.AddmoreArray[index].funding_quantity === '') {
             this.AddmoreArray[index].funding_quantity = 0
          }
            this.AddmoreArray[index].total_price = this.AddmoreArray[index].funding_quantity * this.AddmoreArray[index].unit_price
            this.getGrandTotalInfo()
      },
      FundingQuantityChangeArray (item, index) {
          const objTwo = index
        //   var funding = this.AddmoreArray[objTwo].funding_quantity
                var fundingquan = parseInt(item.funding_quantity) || 0
                var totalPrice = fundingquan * item.unit_price
                const addMoreObj = {
                    assistive_device_id: item.assistive_device_id,
                    budget_id: item.budget_id,
                    created_at: item.created_at,
                    funding_quantity: fundingquan,
                    id: item.id,
                    requisition_quantity: item.requisition_quantity,
                    total_price: totalPrice,
                    unit_price: item.unit_price,
                    updated_at: item.updated_at
                }
                this.AddmoreArray.splice(objTwo, 1)
                this.AddmoreArray.splice(objTwo, 0, addMoreObj)
      },
      setAssistiveInfo () {
          const obj = this.AddmoreArray.find((element) => element.assistive_device_id === this.addmorelist.assistive_device_id)
          if (obj === undefined) {
              this.myVar = false
          } else {
              this.myVar = true
          }
          this.addmorelist.requisition_quantity = obj.requisition_quantity
          this.addmorelist.unit_price = obj.unit_price
      },
      unitPrice () {
           let totalPrice = 0
           totalPrice = this.addmorelist.funding_quantity * this.addmorelist.unit_price
           if (!isNaN(totalPrice)) {
           this.addmorelist.total_price = totalPrice
           }
      },
      async getFundRecieveInfoTwo () {
        this.loading = true
          var result = await RestApi.getData(awarenessEventServiceBaseUrl, fundRecievedListRetriveTwo, this.data)
          if (result) {
            if (result.data === null) {
                this.loading = false
                return
            }
            if (result.errors) {
                    this.$toast.error({
                        title: 'Error',
                        message: 'This memo no already Exist. Try editing it.'
                    })
            }
          this.AddmoreArray = []
          this.AddmoreArray.push(...result.data.details)
          const assistiveDevCir = []
          const store = this.$store
          this.details = result.data.details
          result.data.details.map((element) => {
             let obj = {}
             obj = store.state.AwarenessEventService.commonObj.assistiveDeviceList.find(item => item.value === element.assistive_device_id)
             if (obj) {
             assistiveDevCir.push(obj)
             }
          })
          this.AssitiveDeviceList = assistiveDevCir
          this.data.fiscal_year_id = result.data.fiscal_year_id
          this.data.memo_no = result.data.memo_no
          this.loading = false
          }
      },
      async getFundRecieveInfo () {
          this.loading = true
          var result = await RestApi.getData(awarenessEventServiceBaseUrl, fundRecievedListRetrive, this.data)
          if (result.success) {
            // if (result.data === null) {
            //     this.loading = false
            //     return
            // }
            // if (result.errors) {
            //         this.$toast.error({
            //             title: 'Error',
            //             message: 'This memo no already Exist. Try editing it.'
            //         })
            // }
            this.AddmoreArray = []
            this.AddmoreArray.push(...result.data.details)
            const assistiveDevCir = []
            const store = this.$store
            this.details = result.data.details
            result.data.details.map((element) => {
               let obj = {}
               obj = store.state.AwarenessEventService.commonObj.assistiveDeviceList.find(item => item.value === element.assistive_device_id)
               if (obj) {
               assistiveDevCir.push(obj)
               }
            })
            this.getGrandTotalInfo()
            this.AssitiveDeviceList = assistiveDevCir
            this.data.fiscal_year_id = result.data.fiscal_year_id
            this.data.memo_no = result.data.memo_no
            this.loading = false
          } else {
            this.$toast.error({
                title: 'Error',
                message: result.message,
                color: '#a61927'
            })
            this.loading = false
          }
        },
        addItem () {
            const objTwo = this.AddmoreArray.findIndex((element) => element.assistive_device_id === this.addmorelist.assistive_device_id)
            if (objTwo !== -1) {
                var funding = this.AddmoreArray[objTwo].funding_quantity
                if (funding === undefined) {
                        const addMoreObj = {
                        assistive_device_id: this.addmorelist.assistive_device_id,
                        budget_id: this.addmorelist.budget_id,
                        created_at: this.addmorelist.created_at,
                        funding_quantity: this.addmorelist.funding_quantity,
                        id: this.addmorelist.id,
                        requisition_quantity: this.addmorelist.requisition_quantity,
                        total_price: this.addmorelist.total_price,
                        unit_price: this.addmorelist.unit_price,
                        updated_at: this.addmorelist.updated_at
                    }
                    this.getGrandTotalInfo()
                    this.AddmoreArray.splice(objTwo, 1)
                    this.AddmoreArray.splice(objTwo, 0, addMoreObj)
                    // this.AddmoreArray[objTwo].funding_quantity = 100
                } else {
                    var fundingquan = parseInt(this.addmorelist.funding_quantity) + parseInt(funding)
                    var totalPrice = fundingquan * this.addmorelist.unit_price
                    const addMoreObj = {
                        assistive_device_id: this.addmorelist.assistive_device_id,
                        budget_id: this.addmorelist.budget_id,
                        created_at: this.addmorelist.created_at,
                        funding_quantity: fundingquan,
                        id: this.addmorelist.id,
                        requisition_quantity: this.addmorelist.requisition_quantity,
                        total_price: totalPrice,
                        unit_price: this.addmorelist.unit_price,
                        updated_at: this.addmorelist.updated_at
                    }
                    this.AddmoreArray.splice(objTwo, 1)
                    this.AddmoreArray.splice(objTwo, 0, addMoreObj)
                }
                this.addmorelist = []
            } else {
                const obj = {
                assistive_device_id: this.addmorelist.assistive_device_id,
                requisition_quantity: this.addmorelist.requisition_quantity,
                funding_quantity: this.addmorelist.funding_quantity,
                unit_price: this.addmorelist.unit_price,
                total_price: this.addmorelist.total_price
            }
            this.validationArray.push(obj)
            const validation = this.validationArray.every(item => item.assistive_device_id && item.requisition_quantity && item.funding_quantity && item.unit_price && item.total_price)
                if (validation === false) {
                    this.$toast.success({
                            title: 'Error',
                            message: 'Please Fill all three fields',
                            color: '#a61927'
                    })
                    this.validationArray = []
                } else {
                    this.AddmoreArray.push(obj)
                    this.addmorelist = []
                    this.getGrandTotalInfo()
                }
            }
            this.$nextTick(() => {
                this.$refs.form.reset()
            })
        },
        delItem (index) {
            this.AddmoreArray.splice(index, 1)
            this.getGrandTotalInfo()
        },
        getofficeTypeList (orgId = null) {
            const instituteTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0)
            if (orgId) {
                return instituteTypeList.filter(institute => institute.org_id === orgId)
            }
            return instituteTypeList
        },
        getOfficeList (typeId = null) {
            const instituteList = this.$store.state.commonObj.officeList.filter(item => item.status === 0)
            if (typeId) {
                return instituteList.filter(institute => institute.office_type_id === typeId)
            }
            return instituteList
        },
        async register () {
            localStorage.setItem('isregister', 'true')
            this.loading = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }
            this.data.AddmoreArrayO = []
            this.data.AddmoreArrayO = this.AddmoreArray
            if (this.id) {
                var formData = new FormData()
                Object.keys(this.data).map(key => {
                if (key === 'AddmoreArrayO') {
                formData.append('AddmoreArrayO', JSON.stringify(this.data.AddmoreArrayO))
                } else {
                formData.append(key, this.data[key])
                }
                })
                formData.append('idd', this.id)
                result = await RestApi.postData(awarenessEventServiceBaseUrl, fundRecievedUpdate, formData)
            } else {
                result = await RestApi.postData(awarenessEventServiceBaseUrl, fundRecievedStore, this.data)
            }
            this.$store.dispatch('mutateCommonProperties', loadinState)
            if (result.success) {
                this.loading = false
                this.$store.dispatch('HospitalDisabilityService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$store.dispatch('AwarenessEventService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                title: this.$t('globalTrans.success'),
                message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                color: '#D6E09B'
                })
                this.$bvModal.hide('modal-4')
            } else {
                    // this.$toast.error({
                    // title: this.$t('globalTrans.error'),
                    // message: 'Duplicate entry this memo already exist',
                    // color: '#910f06'
                    // })
                this.loading = false
                this.$refs.form.setErrors(result.errors)
            }
        },
        getData () {
            const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
            this.getGrandTotalInfo()
            return JSON.parse(JSON.stringify(tmpData))
        },
        getGrandTotalInfo () {
           let totalRequistionQuantity = 0
           let totalFundingQuantity = 0
           let totalPrice = 0
            this.AddmoreArray.forEach(item => {
                totalRequistionQuantity += parseInt(item.requisition_quantity)
                totalFundingQuantity += item.funding_quantity ? parseInt(item.funding_quantity) : 0
                totalPrice += parseFloat(item.total_price)
            })
            this.grandTotalInfo = Object.assign({}, this.grandTotalInfo, {
               requisition_quantity: totalRequistionQuantity,
               funding_quantity: totalFundingQuantity,
               total_price: totalPrice
            })
        }
    }
}
</script>

<style>
body {
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}

table, th, td {
  border: solid 1px #000;
  padding: 10px;
  color: black;
}

table {
    border-collapse:collapse;
    caption-side:bottom;
}

caption {
  font-size: 16px;
  font-weight: bold;
  padding-top: 5px;
}
.toast-title {
  color:white;
}
.toast-message {
    color:white;
}
.is-valid {
        padding-right: 0px!important;
}
</style>
